module.exports = global["surveylab_charts_googleChartsExample"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./google-charts-example.ts");